export enum ServiceTextKeys {
  SERVICE_MESSAGE_CONTEXT_CLEARED,
  SERVICE_MESSAGE_VOICE_CALL_ENDED,
  SERVICE_MESSAGE_REQUEST_STOPPED,
}

export const serviceTextMap: Record<ServiceTextKeys, string> = {
  [ServiceTextKeys.SERVICE_MESSAGE_CONTEXT_CLEARED]: "Контекст очищен",
  [ServiceTextKeys.SERVICE_MESSAGE_VOICE_CALL_ENDED]: "Разговор завершен",
  [ServiceTextKeys.SERVICE_MESSAGE_REQUEST_STOPPED]:
    "Обработка запроса приостановлена",
};

export const getServiceMessageTextByKey = (serviceMessageKey: string) => {
  const keyIndex = Number(
    ServiceTextKeys[serviceMessageKey as keyof typeof ServiceTextKeys]
  );
  if (!isNaN(keyIndex)) {
    return serviceTextMap[keyIndex as ServiceTextKeys];
  }
  return serviceMessageKey;
};
